import type { IconSvgObject } from './types';

const SeparatorVerticalIcon: IconSvgObject = [
  ["path", { d: "M11.9923 3L11.9923 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.99216 8C6.99216 8 2.9922 11.0639 2.99219 12C2.99218 12.9362 6.99219 16 6.99219 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.9922 8C16.9922 8 20.9922 11.0639 20.9922 12C20.9922 12.9362 16.9922 16 16.9922 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SeparatorVerticalIcon;
